import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';

import * as api from 'api';


export const fetchClaimThumbs = createAsyncThunk(
  'claimThumbs/fetchClaimThumbs',
  async (debateId, thunkAPI) => {
    const ownerId = thunkAPI.getState().auth.profile.uid;
    const thumbsById = await api.getResource('claimThumbs', {
      relativePath: debateId,
    });
    const collection = {};
    _.each(thumbsById, position => {
      _.each(position, (item, key) => {
        item.value = _.get(item, `users[${ownerId}].value`, 0);
        delete item.users;
        collection[key] = item;
      });
    });
    return collection;
  }
);

export const voteThumbUp = createAsyncThunk(
  'claimThumbs/voteThumbUp',
  async (props, thunkAPI) => {
    const ownerId = thunkAPI.getState().auth.profile.uid;
    const debateId = props.debateId;
    const positionId = props.positionId;
    const claimId = props.claimId;

    const resourceName = 'claimThumbs';
    const basePath = `${debateId}/${positionId}/${claimId}`;
    const entry = { ...props, value: 1 };

    const addVote = api.addResource(resourceName, entry, {
      relativePath: `${basePath}/users/${ownerId}`,
      unique: true,
    });

    const updateCounter = api.increase(resourceName, {
      relativePath: `${basePath}/totalUp`,
    });

    return await Promise
      .all([addVote, updateCounter])
      .then(([vote, total]) => ({ ...vote, total }));
  }
);

export const unvoteThumbUp = createAsyncThunk(
  'claimThumbs/unvoteThumbUp',
  async (props, thunkAPI) => {
    const ownerId = thunkAPI.getState().auth.profile.uid;
    const debateId = props.debateId;
    const positionId = props.positionId;
    const claimId = props.claimId;

    const resourceName = 'claimThumbs';
    const basePath = `${debateId}/${positionId}/${claimId}`;

    const deleteVote = api.deleteResource(resourceName, {
      relativePath: `${basePath}/users/${ownerId}`,
    });
    const updateCounter = api.decrease(resourceName, {
      relativePath: `${basePath}/totalUp`,
    });

    return await Promise
      .all([deleteVote, updateCounter])
      .then(([vote, total]) => ({ ...vote, total }));
  }
);

export const voteThumbDown = createAsyncThunk(
  'claimThumbs/voteThumbDown',
  async (props, thunkAPI) => {
    const ownerId = thunkAPI.getState().auth.profile.uid;
    const debateId = props.debateId;
    const positionId = props.positionId;
    const claimId = props.claimId;

    const resourceName = 'claimThumbs';
    const basePath = `${debateId}/${positionId}/${claimId}`;
    const entry = { ...props, value: -1 };

    const addVote = api.addResource(resourceName, entry, {
      relativePath: `${basePath}/users/${ownerId}`,
      unique: true,
    });

    const updateCounter = api.increase(resourceName, {
      relativePath: `${basePath}/totalDown`,
    });

    return await Promise
      .all([addVote, updateCounter])
      .then(([vote, total]) => ({ ...vote, total }));
  }
);

export const unvoteThumbDown = createAsyncThunk(
  'claimThumbs/unvoteThumbDown',
  async (props, thunkAPI) => {
    const ownerId = thunkAPI.getState().auth.profile.uid;
    const debateId = props.debateId;
    const positionId = props.positionId;
    const claimId = props.claimId;

    const resourceName = 'claimThumbs';
    const basePath = `${debateId}/${positionId}/${claimId}`;

    const deleteVote = api.deleteResource(resourceName, {
      relativePath: `${basePath}/users/${ownerId}`,
    });
    const updateCounter = api.decrease(resourceName, {
      relativePath: `${basePath}/totalDown`,
    });

    return await Promise
      .all([deleteVote, updateCounter])
      .then(([vote, total]) => ({ ...vote, total }));
  }
);

const slice = createSlice({
  name: 'claimThumbs',
  initialState: {
    pending:false,
    error : null,
    byId: {
      //'claimId': {
      //  value: 0,
      //  totalUp: 0,
      //  totalDown: 0,
      //}
    },
  },
  reducers: {
    resetClaimThumbs(state) {
      state.byId = {};
    },
  },
  extraReducers: {
    // ---------------------------------------------------- fetchClaimThumbs
    [fetchClaimThumbs.pending]: (state, action) => {
      state.pending = true;
      state.error = null;
      state.byId = {};
    },
    [fetchClaimThumbs.fulfilled]: (state, action) => {
      state.pending = false;
      state.byId = action.payload;
    },
    [fetchClaimThumbs.rejected]: (state, action) => {
      state.pending = false;
      state.error = action.error;
    },
    // ---------------------------------------------------- voteThumbUp
    [voteThumbUp.pending]: (state, action) => {
      state.pending = true;
      state.error = null;
    },
    [voteThumbUp.fulfilled]: (state, action) => {
      const claimId = action.meta.arg.claimId;
      state.pending = false;
      if (_.isUndefined(state.byId[claimId])) {
        state.byId[claimId] = {};
      }
      state.byId[claimId]['value'] = action.payload.value;
      state.byId[claimId]['totalUp'] = action.payload.total;
    },
    [voteThumbUp.rejected]: (state, action) => {
      state.pending = false;
      state.error = action.error;
    },
    // ---------------------------------------------------- unvoteThumbUp
    [unvoteThumbUp.pending]: (state, action) => {
      state.pending = true;
      state.error = null;
    },
    [unvoteThumbUp.fulfilled]: (state, action) => {
      const claimId = action.meta.arg.claimId;
      state.pending = false;
      state.byId[claimId] = {
        value: 0,
        totalUp: action.payload.total,
      };
    },
    [unvoteThumbUp.rejected]: (state, action) => {
      state.pending = false;
      state.error = action.error;
    },
    // ---------------------------------------------------- voteThumbDown
    [voteThumbDown.pending]: (state, action) => {
      state.pending = true;
      state.error = null;
    },
    [voteThumbDown.fulfilled]: (state, action) => {
      const claimId = action.meta.arg.claimId;
      state.pending = false;
      state.byId[claimId] = {
        value: action.payload.value,
        totalDown: action.payload.total,
      };
    },
    [voteThumbDown.rejected]: (state, action) => {
      state.pending = false;
      state.error = action.error;
    },
    // ---------------------------------------------------- unvoteThumbDown
    [unvoteThumbDown.pending]: (state, action) => {
      state.pending = true;
      state.error = null;
    },
    [unvoteThumbDown.fulfilled]: (state, action) => {
      const claimId = action.meta.arg.claimId;
      state.pending = false;
      state.byId[claimId] = {
        value: 0,
        totalDown: action.payload.total,
      };
    },
    [unvoteThumbDown.rejected]: (state, action) => {
      state.pending = false;
      state.error = action.error;
    },
  },
});

const { actions, reducer } = slice;
export const { resetClaimThumbs } = actions;
export default reducer;
